import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from "vue"
import { useSalesBotStore } from "@/store/modules/salesBot"
import auth from "@/store/modules/auth";
import SalesBotVehicleOptionCard from "@/components/SalesBotVehicleOptionCard.vue"
import { useGoogleAnalytics, Event } from "@/composables/useGoogleAnalytics"
import { useAuth0 } from "@/composables/useAuth0"


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotVehicles',
  emits: ["form:validate"],
  setup(__props, { emit }) {

const salesBotStore = useSalesBotStore()
const { setSelectedVehicleOption, setEstimatedPrice } = salesBotStore

const vehicles = computed(() => salesBotStore.vehicles)
const vehicleOptions = computed(() => salesBotStore.vehicleOptions)
const vehicleOptionsLoading = computed(
  () => salesBotStore.vehicleOptionsLoading
)
const vehicleOptionsEmpty = computed(() => {
  return vehicleOptions.value.length === 0
})

const select = (vehicleOptionIndex): void => {
  setSelectedVehicleOption(vehicleOptionIndex)

  const amount = vehicleOptions.value[vehicleOptionIndex].amount
  if (amount) {
    setEstimatedPrice(amount)
  }
}



const auth0 = useAuth0()
const analytics = useGoogleAnalytics()

function trackViewVehicleTypeOptions(): void {
  const isLoggedIn = !!auth.isTokenSet && !!auth.userId
  const hasBookedBefore = auth?.customer?.convertedQuoteCount > 0

  analytics.trackEvent(Event.ViewOptions, {
    isAuth0: auth0.isInitialized,
    hasBookedBefore,
    isLoggedIn,
  })
}

watch(vehicles, () => {
  validate()
  trackViewVehicleTypeOptions()
})

const validate = (): boolean => {
  const isValid =
    vehicleOptions.value.filter(({ selected }) => selected).length === 1 &&
    vehicles.value.length > 0
  emit("form:validate", isValid)
  return isValid
}

return { __sfc: true,salesBotStore, setSelectedVehicleOption, setEstimatedPrice, vehicles, vehicleOptions, vehicleOptionsLoading, vehicleOptionsEmpty, select, emit, auth0, analytics, trackViewVehicleTypeOptions, validate, SalesBotVehicleOptionCard }
}

})